import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.settings/view.scss */
/* src/app/page.admin.settings/view.scss: no such file or directory */`],
})
export class PageAdminSettingsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public configs: any = {};
    public geminiTestResult: string = '';
    public testing: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.configs = data;
            if (!this.configs.gemini_api_key) this.configs.gemini_api_key = '';
            if (!this.configs.gemini_model) this.configs.gemini_model = 'gemini-2.0-flash';
            if (!this.configs.clinic_name) this.configs.clinic_name = '';
            if (!this.configs.clinic_address) this.configs.clinic_address = '';
            if (!this.configs.clinic_phone) this.configs.clinic_phone = '';
            if (!this.configs.clinic_license) this.configs.clinic_license = '';
            if (!this.configs.session_timeout) this.configs.session_timeout = '3600';
            if (!this.configs.max_chat_history) this.configs.max_chat_history = '50';
        }
        await this.service.render();
    }

    public async saveAll() {
        const { code } = await wiz.call("save_bulk", { data: JSON.stringify(this.configs) });
        if (code === 200) {
            await this.service.modal.show({ title: '저장 완료', message: '설정이 저장되었습니다.', action: '확인' });
        }
    }

    public async testGemini() {
        this.testing = true;
        this.geminiTestResult = '';
        await this.service.render();

        const { code, data } = await wiz.call("test_gemini", { api_key: this.configs.gemini_api_key });
        this.testing = false;
        if (code === 200) {
            this.geminiTestResult = '✅ 연결 성공: ' + data.message;
        } else {
            this.geminiTestResult = '❌ 연결 실패: ' + (data.message || '알 수 없는 오류');
        }
        await this.service.render();
    }
}

export default PageAdminSettingsComponent;